import { BookingSourceContainer } from "@/lib/booking_source/container"
import { BookingSourceContext } from "@/lib/booking_source/context"

export namespace BookingSource {
  export type ContextData = {
    bookingSource?: string
    setBookingSource: (bookingSource?: string) => void
  }

  export const Container = BookingSourceContainer
  export const Context = BookingSourceContext
}
